import React, { useEffect, useRef, useState } from "react";
import PauseIcon from "../../../assets/icons/svg/PauseIcon";
import PlayerPlayIcon from "../../../assets/icons/svg/PlayerPlayIcon";
import { setPltvPaused } from "../../../statics/config";
import localizationStrings from "../../../statics/localization";
import { reportingEvent } from "../../../statics/reportEventId";
import { TRACK_IDS } from "../../../analytics/trackIds";
import { playSafely } from "../playSafely";

const PlayButton = ({
  player,
  setIsPaused,
  sendMediaReport,
  isPltv,
  setIsLiveEdge,
  cuTvProgram,
  myTvChannelProgram,
  liveui,
  isTimeshiftEnable
}) => {
  const [paused, setPaused] = useState(() => player?.paused() ?? true);
  const syncPlayback = useRef(null);
  const isPltvRef = useRef(null);
  const cuTvRef = useRef(null);
  const myTvRef = useRef(null);

  useEffect(() => {
    isPltvRef.current = isPltv;
  }, [isPltv]);

  useEffect(() => {
    cuTvRef.current = cuTvProgram;
  }, [cuTvProgram]);

  useEffect(() => {
    myTvRef.current = myTvChannelProgram;
  }, [myTvChannelProgram]);

  useEffect(() => {
    const sync = () => {
      if (player.isDisposed?.()) return;
      const value = player.paused();
      setPaused(value);
      setIsPaused(value);
    };
    syncPlayback.current = sync;
    ["play", "playing", "pause", "loadeddata"].forEach(event => player.on(event, sync));
    sync();
    return () => {
      syncPlayback.current = null;
      ["play", "playing", "pause", "loadeddata"].forEach(event => player.off(event, sync));
    };
  }, [player, setIsPaused]);

  return (
    <button
      className="control-button"
      data-track-id={TRACK_IDS.PLAYER_PLAY_PAUSE}
      style={{
        marginLeft: "0",
        cursor: "pointer"
      }}
      title={
        paused
          ? localizationStrings.playerOptions.play
          : localizationStrings.playerOptions.pause
      }
      onClick={() => {
          if (player.paused()) {
            playSafely(player).then(played => {
              if (syncPlayback.current) syncPlayback.current();
              if (played) sendMediaReport(reportingEvent.E_MEDIA_PLAY);
            });
          } else {
            sendMediaReport(reportingEvent.E_MEDIA_PAUSE);
            player.pause();
            if (syncPlayback.current) syncPlayback.current();
            if (
              liveui &&
              isTimeshiftEnable &&
              !isPltvRef.current &&
              !cuTvRef.current?.prevuecode &&
              !myTvRef.current?.programcode
            ) {
              setIsLiveEdge("1");
              setPltvPaused(true);
            }
          }
      }}
    >
      <div style={{ display: paused ? "flex" : "none" }}>
        <PlayerPlayIcon />
      </div>
      <div style={{ display: paused ? "none" : "flex" }}>
        <PauseIcon />
      </div>
    </button>
  );
};

export default PlayButton;
